/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

export const environment = {
  production: true,
  app_url: window.location.origin,
  api_url: window.location.origin + '/cecews',
  cecewm_version: '2.2.1',
  cookie_domain: window.location.hostname,
  cookie_analytics_id: 'G-0BWBZ0LVY9',
  recaptcha_v3_site_key: '6Ld-1GUaAAAAAO-rgH_1buXbLiGLvCPX8pkeQgm8',
  recaptcha_v2_site_key: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  recaptcha_v3_testing: 'CertusSoftwareErasureConsumerForCaptchaTestingSpecialTextTherearemanyvariationsofpassagesofLoremIpsumavailablebutthemajorityhavesufferedalterationinsomeform',
  redirectBasePath: '/',
  defaultLanguage: 'hu',
  defaultLanguageOrder: ['hu', 'en'],
  resources: {
    customerPortal: 'https://certussoftware.hu/',
    websiteOrMail: 'info@nmhh.hu',
    contactAt: 'https://certussoftware.hu/',
    cutDownloadUrl: window.location.origin + '/download/products/ceceut/hu/cece_usb_tool_setup.msi',
    ceceQuickGuideUrl: window.location.origin + '/download/products/cece/manuals/',
    ceceReleaseNotesUrl: window.location.origin + '/download/products/cecede/manuals/CECEDE_Release_Notes.pdf',
    ceceadReleaseNotesUrl: window.location.origin + '/download/products/ceceae/manuals/CECEAE_Release_Notes.pdf',
    ceceieReleaseNotesUrl: window.location.origin + '/download/products/ceceie/manuals/CECEIE_Release_Notes.pdf',
    cecewmReleaseNotesUrl: window.location.origin + '/download/products/cecewm/manuals/CECEWM_Release_Notes.pdf'
  }
};
